var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .infoColored{fill:#1bc47d}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18695",
    "data-name": "Group 18695",
    transform: "translate(-11025.242 1283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Status_Info-circle",
    "data-name": "Outline / Status /Info-circle",
    transform: "translate(11025.242 -1283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info-circle",
    transform: "translate(-.25 -.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.75 17.5a8.75 8.75 0 1 1 8.75-8.75 8.76 8.76 0 0 1-8.75 8.75zm0-16A7.25 7.25 0 1 0 16 8.75 7.258 7.258 0 0 0 8.75 1.5z",
    transform: "translate(.25 .25)",
    style: {
      fill: "#8c8d99"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18693",
    "data-name": "Group 18693",
    transform: "translate(-2.008 -14.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "infoColored",
    d: "M5 3.321A1.787 1.787 0 0 0 3.25 1.5 1.787 1.787 0 0 0 1.5 3.321 1.819 1.819 0 0 0 2.668 5.04 1.9 1.9 0 0 1 4 6.75a.75.75 0 0 1-1.5 0 .182.182 0 0 0-.061-.118.735.735 0 0 0-.287-.184A3.319 3.319 0 0 1 0 3.321 3.286 3.286 0 0 1 3.25 0 3.286 3.286 0 0 1 6.5 3.321a.75.75 0 0 1-1.5 0z",
    transform: "translate(11032.75 -1264.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "infoColored",
    d: "M1 2a1 1 0 1 1 1-1 1 1 0 0 1-1 1z",
    transform: "translate(11035 -1256)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoColored);
export default __webpack_public_path__ + "static/media/info-colored.fbf550fa9333ad5c479bb9dd723fc23f.svg";
export { ForwardRef as ReactComponent };